import { Component } from '@angular/core';

@Component({
  selector: 'app-subsetting',
  templateUrl: './subsetting.component.html',
  styleUrls: ['./subsetting.component.css']
})
export class SubsettingComponent {

}
